import { Injectable } from '@angular/core';
import * as detectbrowser from 'detect-browser';

@Injectable()
export class CoreService {
  constructor() {}

  browserSupported(): boolean {
    const browser = detectbrowser.detect();

    switch (browser && browser.name) {
      case 'chrome':
      case 'firefox':
      case 'edge':
        return true;
      default:
        return false;
    }
  }

  parseStringToNumber(value: string): number {
    return parseFloat(value);
  }
}
